import type {Infinity} from '../services/InfinityClient.service';

export type ServiceType = ReturnType<Infinity['getServiceType']>;

/**
 * Derive the label presented for the ongoing meeting, e.g. in the meeting
 * header or by the platform's media controls.
 */
export const getMeetingTitle = ({
    serviceType,
    conferenceName,
    conferenceAlias,
    remoteAlias,
}: {
    serviceType: ServiceType;
    conferenceName?: string;
    conferenceAlias?: string;
    remoteAlias?: string;
}) => {
    switch (serviceType) {
        case 'conference':
        case 'lecture':
            return conferenceName;
        case 'gateway':
            return remoteAlias ?? conferenceAlias;
        default:
            return undefined;
    }
};
